/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

import React from 'react';
import { Dropdown, Image } from 'react-bootstrap';

import {
  DotsVerticalIcon,
  XCircleIcon,
  EyeIcon,
  InformationCircleIcon,
  TrashIcon,
} from '@heroicons/react/solid';

import * as S from './styles';

export interface ToggleActionProps {
  actionMenu?: {
    key: string;
    label: string;
  }[];
  onActionClick?(key: string): void;
}

export const ToggleAction = (props: ToggleActionProps) => {
  const { actionMenu, onActionClick } = props;

  const onToggleClick = (key: string) => {
    onActionClick && onActionClick(key);
  };

  const getIcon = (item: any) => {
    if (item?.icon) {
      return (
        <Image
          src={item?.icon}
          width={16}
          height={16}
          roundedCircle
          className="me-2"
        />
      );
    } else {
      switch (item?.key) {
        case 'remove':
          return <XCircleIcon className="dropdown-icon text-gray-400 me-2" />;
        case 'view':
          return <EyeIcon className="dropdown-icon text-gray-400 me-2" />;
        default:
          return (
            <InformationCircleIcon className="dropdown-icon text-gray-400 me-2" />
          );
      }
    }
    return null;
  };

  const _getToggleItems = () => {
    let _menuItems: any = [];
    if (Array.isArray(actionMenu) && actionMenu?.length > 0) {
      actionMenu?.map((element, index) => {
        if (element?.key === 'delete') {
          _menuItems.push(
            <>
              <Dropdown.Divider as="div" className="my-1" />
              <Dropdown.Item
                key={`${element?.key}-${index}`}
                variant="link"
                className="d-flex align-items-center text-danger ms-0"
                onClick={(e) => {
                  onToggleClick(element?.key);
                  e.stopPropagation();
                }}
              >
                <TrashIcon className="dropdown-icon text-danger me-2" />{' '}
                {element?.label}
              </Dropdown.Item>
            </>
          );
        } else {
          _menuItems.push(
            <Dropdown.Item
              key={`${element?.key}-${index}`}
              className="d-flex align-items-center"
              onClick={(e) => {
                onToggleClick(element?.key);
                e.stopPropagation();
              }}
            >
              {getIcon(element)}
              {element?.label}
            </Dropdown.Item>
          );
        }
      });
    }
    return _menuItems;
  };
  if (Array.isArray(actionMenu) && actionMenu?.length > 0) {
    return (
      <Dropdown
        as={S.ButtonGroupComp}
        onClick={(e: any) => {
          e.stopPropagation();
        }}
      >
        <Dropdown.Toggle
          as={S.ButtonComp}
          split
          variant="link"
          className="m-0 p-0"
        >
          <DotsVerticalIcon className="icon icon-xs" color="gray" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="mt-2 py-1">{_getToggleItems()}</Dropdown.Menu>
      </Dropdown>
    );
  }
  return <></>;
};
